import React from "react";
import { connect, DispatchProp } from "react-redux";
import IStore from "models/IStore";
import IAction from "models/IAction";
import { Col, Row } from "react-bootstrap";
import FormatUtility from "utilities/FormatUtility";
import DateFormatEnum from "constants/DateFormatEnum";
import NotaValoriModel from "../../../stores/note/models/NotaValoriModel";

interface IProps {
    readonly noteType: NotaValoriModel;
    readonly userName: string;
    readonly userSurname: string;
    readonly insertDate: string;
    readonly description: string;
    readonly background: string;
}

interface IState {}

interface IStateToProps {}

const mapStateToProps = (state: IStore): IStateToProps => ({});

class NoteMessage extends React.Component<IProps & IStateToProps & DispatchProp<IAction<any>>, IState> {
    public render(): JSX.Element | null {
        const { noteType, userName, userSurname, insertDate, description, background } = this.props;

        const fullName = userName + " " + userSurname;

        return (
            <>
                <Row className={["p-3 mt-2", `background-${background}`].join(" ")}>
                    <Col sm={12} md={2} className="border-right">
                        <div className="font-weight-bold">{noteType.value.toUpperCase()}</div>
                        <div>{fullName}</div>
                        <div>{FormatUtility.dateInGivenFormat(insertDate, DateFormatEnum.ITA_DATE_TIME_SECONDS)}</div>
                    </Col>
                    <Col sm={12} md={10}>
                        <div>{description}</div>
                    </Col>
                </Row>
            </>
        );
    }
}

export { NoteMessage as Unconnected };
export default connect(mapStateToProps)(NoteMessage);
